/**
 * Utility layers shown on the permitting-request map embed (layer picker hidden).
 *
 * Every ID must exist as a `key` in the tileLayers table; the CG-303 parity test
 * (packages/db/scripts/seedTileLayers/index.test.ts) checks this list against the
 * seed source tile_url_map.csv, so keep this file dependency-free for that import.
 * Caveat: parity is enforced against the CSV, not the live table — if db-driven-layers
 * lets tileLayers drift from the CSV (CG-300/CG-306), divergence won't be caught.
 */
export const PERMITTING_VISIBLE_UTILITY_LAYER_IDS = [
  'sanitaryPipes',
  'sanitaryPoints',
  'gasTransmission',
  'gasDistribution',
  'gasService',
  'gasPoints',
  'gasDistanceArrow',
  'waterPoints',
  'waterMain',
  'waterService',
  'waterTransmission',
] as const;
